import gql from 'graphql-tag'

import { serverTaskFields } from './fragments'

export default gql`
mutation CA_web_updateAutomationTaskServer($id: ID!, $fields: AutomationTaskServerInput!) {
	cashAssist {
		updateAutomationTaskServer(id: $id, fields: $fields) {
			...autoTasksServerFields
		}
	}
}
${serverTaskFields}`
